import $ from "jquery";

import LangSelector from "./components/lang-selector";
import SiteHeader from "./components/site-header";
import HomeSlider from "./components/home-slider";
import NewsSlider from "./components/news-slider";
import ReviewsSlider from "./components/reviews-slider";
import PartnersSlider from "./components/partners-slider";
import PortalPageSlider from "./components/portal-page-slider";
import HandheldMenu from "./components/handheld-menu";
import DesktopMenu from "./components/desktop-menu";
import CookiesConsent from "./components/cookies-consent";
import DropdownMenu from "./components/dropdown-menu";
import Accordion from "./components/accordion";
import NewsletterForm from "./components/newsletter-form";
import DeviceManager from "./utils/device-manager";
import TableHide from "./components/table-hide";
import Sharebar from "./components/sharebar";
import EstateSlider from "./components/estate-slider";

$(function () {
	const bootstrapApp = () => {
		const $html = $("html");

		// Touch device detection
		if (DeviceManager.isHandheld()) {
			$html.addClass("touch");

			if (DeviceManager.isIos()) {
				$html.addClass("ios");
			}
		} else {
			$html.addClass("no-touch");
		}

		// IE detection
		if (DeviceManager.isIe11()) {
			$html.addClass("ie11");
		} else if (DeviceManager.isEdge()) {
			$html.addClass("edge");
		}
	};

	const instanciateComponents = () => {
		// General components
		const langSelector = new LangSelector($(".language-selector"));
		const siteHeader = new SiteHeader($(".site-header"), 20);

                // Home slider component
		const $homesSliders = $(".homepage-header__slider");
		if ($homesSliders.length) {
			$homesSliders.each(function (index, el) {
				const homeSlider = new HomeSlider($(el));
			});
		}

		// News slider component
		const $newsSliders = $(".news-list--slider");
		if ($newsSliders.length) {
			$newsSliders.each(function (index, el) {
				const newsSlider = new NewsSlider($(el));
			});
		}

		// Partners slider component
		const $partnersSliders = $(".partners-slider");
		if ($partnersSliders.length) {
			$partnersSliders.each(function (index, el) {
				const partnerSlider = new PartnersSlider($(el));
			});
		}

		// Reviews slider component
		const $reviewsSlider = $(".reviews-slider");
		if ($reviewsSlider.length) {
			$reviewsSlider.each(function (index, el) {
				const reviewsSlider = new ReviewsSlider($(el));
			});
		}

		// Estate page slider component
		// const $estateSliders = $(".estates-list");
		// if ($estateSliders.length) {
		// 	$estateSliders.each(function (index, el) {
		// 		const estateSlider = new EstateSlider($(el));
		// 	});
		// }

		// Cookie consent
		if (typeof tarteaucitron !== "undefined" && tarteaucitron) {
			// Tarteaucitron cookie settings
			let tarteaucitronLang = "fr";

			const cookiesConsent = new CookiesConsent(tarteaucitronLang);
		}

		// Système de filtres pour la version responsive des offres de biens
		// $('.filter-mobile').on('click', function(event) {
		// 	event.preventDefault;
		// 	$('.estate-search-form').toggleClass('filters--openned');
		// 	$(this).toggleClass('filters--openned');
		// })
		// $('.close-filters').on('click', function() {
		// 	$('.estate-search-form').toggleClass('filters--openned');
		// 	$('.filter-mobile').toggleClass('filters--openned');
		// })

		// // Dynamisation des listes à choix multiples (checkbox)
		// var checkList = document.querySelectorAll('.dropdown-check-list');
		// checkList.forEach(
		// 	element => element.getElementsByClassName('anchor')[0].onclick = function(evt) {
		// 		if (element.classList.contains('visible'))
		// 			element.classList.remove('visible');
		// 		else
		// 			element.classList.add('visible');
		// 		}
		// );

		// Ajout d'un span autour du contenu textuel des titres <h2>
		$('.heading--h2').each(
			function(){
				$(this).wrapInner('<span></span>');
			});
	};

	bootstrapApp;
	instanciateComponents();
});

